import type { Id } from '@e-socna/data-layer';

export const checkIfIsId = (value: unknown): value is Id =>
  typeof value === 'string' && /^[0-9a-fA-F]{24}$/.test(value);
